export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Test Data Security', description: 'Secure handling of test data and PII', priority: 'high' },
      { name: 'Test Environment Access', description: 'Secure access to test environments', priority: 'high' },
      { name: 'Browser Security', description: 'Configure secure browser settings for testing', priority: 'medium' },
      { name: 'API Testing Security', description: 'Secure API testing practices', priority: 'medium' }
    ],
    procedures: [
      { step: 'Configure test data masking', command: 'Use anonymized data for testing' },
      { step: 'Set up VPN access', command: 'Connect to company VPN for test environment access' },
      { step: 'Configure secure browser profiles', command: 'Create isolated browser profiles for testing' },
      { step: 'Secure API credentials', command: 'Store API keys in secure credential management' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Security Testing', description: 'Implement basic security testing practices', priority: 'high' },
      { name: 'Test Automation Security', description: 'Secure test automation frameworks', priority: 'high' },
      { name: 'Vulnerability Testing', description: 'Basic vulnerability testing procedures', priority: 'medium' },
      { name: 'Compliance Testing', description: 'Test for security compliance requirements', priority: 'medium' }
    ],
    procedures: [
      { step: 'Install OWASP ZAP', command: 'docker run -t owasp/zap2docker-stable zap-baseline.py -t https://example.com' },
      { step: 'Configure secure test execution', command: 'Use encrypted connections for test automation' },
      { step: 'Set up vulnerability scanning', command: 'Integrate security scans in CI/CD pipeline' },
      { step: 'Implement security test cases', command: 'Create test cases for common security vulnerabilities' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Test Strategy', description: 'Develop comprehensive security testing strategy', priority: 'high' },
      { name: 'Penetration Testing', description: 'Coordinate penetration testing activities', priority: 'high' },
      { name: 'Security Compliance', description: 'Ensure testing meets security compliance standards', priority: 'high' },
      { name: 'Security Risk Assessment', description: 'Conduct security risk assessments for testing', priority: 'medium' }
    ],
    procedures: [
      { step: 'Design security test framework', command: 'Implement comprehensive security testing framework' },
      { step: 'Configure advanced security tools', command: 'Set up enterprise security testing tools' },
      { step: 'Implement threat modeling', command: 'Conduct threat modeling for test scenarios' },
      { step: 'Security audit procedures', command: 'Establish regular security audit procedures' }
    ]
  }
};
